import React, { forwardRef, useState, useImperativeHandle } from "react";
import { Box, Stack, Typography, IconButton, Divider, FormControl, FormLabel, OutlinedInput } from "@mui/material";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Grid from "@mui/material/Unstable_Grid2/Grid2";

const Note = ({ buttonLabel, label, inputLabel, value, onChange }) => {
    const [displayNoteLayout, setDisplayNoteLayout] = useState(value ? (value ? true : false) : false);
    const [formValues, setFormValues] = useState(value ? value : "");

    const handleAddNoteClick = () => {
        setDisplayNoteLayout(true);
    };

    const handleRemoveClick = () => {
        setDisplayNoteLayout(false);
        setFormValues("");
        onChange("");
    };

    const handleChange = (value) => {
        if (value?.trim() === "") {
        } else {
            let newFormValues = {};
            newFormValues.note = value;
            newFormValues.displayNoteLayout = displayNoteLayout;
            setFormValues(newFormValues.note);
            onChange(value);
        }
    };

    return (
        <Box sx={{ display: "flex" }}>
            {!displayNoteLayout && (
                <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 1 }} onClick={handleAddNoteClick}>
                    <AddCircleOutlineOutlinedIcon color="primary" />
                    <Typography
                        variant="h6"
                        display="block"
                        gutterBottom
                        color="primary.main"
                        sx={{
                            textTransform: "none",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <b>{buttonLabel}</b>
                    </Typography>
                </Stack>
            )}
            {displayNoteLayout && (
                <Box
                    sx={{
                        p: 1,
                        borderRadius: "8px",
                        border: "1px solid #E6E8F0",
                        backgroundColor: "#F8F8F8",
                        overflow: "visible",
                        width: "100%",
                        mb: 2,
                    }}
                >
                    <Grid container spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Grid item>
                            <Typography gutterBottom variant="h5">
                                <b>{label}</b>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <IconButton aria-label="delete" size="small" style={{ float: "right" }}>
                                <DeleteOutlinedIcon
                                    color="error"
                                    fontSize="small"
                                    onClick={() => handleRemoveClick()}
                                />
                            </IconButton>
                        </Grid>
                    </Grid>

                    <Divider sx={{ mt: 1, mb: 1 }} />

                    <FormControl fullWidth variant="outlined">
                        <FormLabel htmlFor="my-input">
                            <Typography gutterBottom variant="subtitle1" sx={{ color: "" }}>
                                {inputLabel}
                            </Typography>
                        </FormLabel>

                        <OutlinedInput
                            id="note"
                            value={formValues}
                            autoFocus={true}
                            onChange={(evnet) => handleChange(evnet.target.value)}
                            multiline={true}
                            rows={4}
                        />
                    </FormControl>
                </Box>
            )}
        </Box>
    );
};

export { Note };
